import { request } from '@/shared/api/request'
export const getSSPData = (bin, isLocal = true) =>
	request({ url: `/contract/universalMethods/requestSSPData?bin=${bin}&isLocal=${isLocal}`, method: 'GET' })
